
<template>
    <div class="py-6 w-full h-full px-3">
        <div class="flex items-center  ml-4 mb-10">
          <BackButton
          label="Back"
          @onClick="$router.back()"
          variant="secondary"
          class="mr-4"
        />
        <div
        class="mt-4"
        style="border-left: 1px solid #878E99; height:1.5rem"
      />
      <h1 class="text-xl  text-left font-extrabold ml-4 mt-3 mr-8">
        General Settings
      </h1>
    </div>


      <Card>
        <Tabs
          class="mt-2 mx-2"
          :tabs="tabsItems"
          :active-tab="activeTab"
          @currentTab="activeTab = $event"
          :border="true"
        />
      </Card>
      <div>
        <PaySchedule
          v-if="activeTab === 'Pay Schedule'"
        />
        <PayPreference
          v-if="activeTab === 'Preference'"
        />
      </div>
    </div>
  </template>

  <script>
  import BackButton from "@scelloo/cloudenly-ui/src/components/back-button";
  import Tabs from "@scelloo/cloudenly-ui/src/components/tab";
  import Card from "@/components/Card";
  import PaySchedule from "./PaySchedule/index";
  import PayPreference from "./PayPreference/index";

  export default {
    components: {
      Tabs,
      Card,
      PayPreference,
      PaySchedule,
      BackButton
    },
    data() {
      return {
        activeTab: 'Pay Schedule',
        tabsItems: [
          "Pay Schedule",
          "Preference",
        ],
      }
    },
    computed: {
      breadcrumbs() {
        return [
          {
            disabled: false,
            text: 'Settings',
            href: '/admin/settings/payrollsettings',
            id: 'Settings'
          },
          {
            disabled: false,
            text: 'Payroll Settings',
            href: 'PayrollSettings',
            id: 'PaySettings'
          },
          {
            disabled: false,
            text: 'General Settings',
            href: '/admin/settings/payrollsettings/general-settings',
            id: 'GeneralSettings'
          }
        ];
      }
    },
    methods: {
      handleBreadcrumbClick(event) {
        if (event === 'PayrollSettings') {
          // Navigate back to Pay Group without any query parameters
          this.$router.push({
            name: 'PayrollSettings',
            query: {}
          });
        } else if (event === 'Settings') {
          this.$router.push('/admin/settings/payrollsettings');
        }
      }
    }
  }
  </script>